<template>
  <div
    id="receptionOver"
    class="main-content"
  >
    <div class="subtitle margin-top-16">
      {{ $t('message["1368"]') }}
    </div>
    <div class="reception-tip-box">
      <a-alert
        :message="alertTip"
        type="info"
        show-icon
      />
    </div>
    <div
      class="reception-tab-box"
    >
      <a-tabs
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          v-if="recStatisticPermission['inquiry-add']"
          key="createSta"
          :tab="createStaTit"
        >
          <reception-main
            v-if="activeName === 'createSta'"
            :type="activeName"
          />
        </a-tab-pane>
        <a-tab-pane
          v-if="recStatisticPermission['inquiry-audit']"
          key="auditSta"
          :tab="auditStaTit"
        >
          <reception-main
            v-if="activeName === 'auditSta'"
            :type="activeName"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ReceptionMain from './components/ReceptionMain'
export default {
  components: {
    ReceptionMain
  },
  data () {
    return {
      activeName: 'createSta'
    }
  },
  computed: {
    ...mapState('statistic', ['loadingContent', 'recStatisticPermission']),
    recType () {
      return this.$route.query.recType
    },
    alertTip () {
      return this.$t('message["1182"]')
    },
    createStaTit () {
      return this.$t('message["1772"]')
    },
    auditStaTit () {
      return this.$t('message["1773"]')
    }
  },
  async created () {
    // 录入统计/审核统计显示权限
    let chain = await this.fetchRecStatisticPermission()
    chain.onSuccess(res => {
      const { 'inquiry-add': add, 'inquiry-audit': audit } = this.recStatisticPermission || {}
      //  录入+审核权限
      if (add && audit) {
        this.activeName = this.recType || 'createSta'
      } else if (add) { // 录入权限
        if (this.recType === 'auditSta') {
          this.$router.push({
            query: {
              ...this.$route.query,
              recType: 'createSta'
            }
          })
        }
        this.activeName = 'createSta'
      } else if (audit) { // 审核权限
        if (this.recType === 'createSta') {
          this.$router.push({
            query: {
              ...this.$route.query,
              recType: 'auditSta'
            }
          })
        }
        this.activeName = 'auditSta'
      }
      this.setReceptionType(this.activeName)
    })
  },
  methods: {
    ...mapActions('statistic', ['fetchRecStatisticPermission']),
    ...mapMutations('statistic', ['setReceptionType']),
    handleClick (e) {
      this.setReceptionType(e)
      this.$router.push({
        name: this.$route.name,
        query: { ...this.$route.query, recType: e }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.spin-css {
  position: absolute;
  top: 50%;
  left: 50%;
}
.reception-tip-box::v-deep {
    margin: 16px 0 ;
    .ant-alert-info{
      border-color:#4CA0F2 ;
      background: #DBEDFF;
    }
  }
.reception-tab-box::v-deep {
    margin-top: 16px;
    .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
      padding: 12px 2px;
    }
    .ant-tabs-nav-scroll {
      top: 0;
      left: 0;
      background: #fff;
      z-index: 1051;
    }
    .iconicon-test30 {
    color: #b3b3b3;
  }
  }
</style>
